const initialState = {
  businessInventoryList: [],
  businessInventoryListLoading: false,
  isDisabled: false,
  currentBarcodeNumber: [],
  categoriesByMenu: [],
  categoriesTotalCount: 0,
  categoriesChangeCount: 0,
  productsByCategory: [],
  productsByMenu: [], // Store as array for better performance
  productsTotalCount: 0, // Store total count from API
  productsChangeCount: 0, // Store change count from API
  totalInventory: 0,
  totalCost: 0,
  totalSales: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_BUSINESS_INVENTORY_LIST':
      return { ...state, businessInventoryList: action.payload };
    case 'SET_BUSINESS_INVENTORY_LIST_LOADING':
      return { ...state, businessInventoryListLoading: action.payload };
    case 'SET_IS_DISABLED':
      return { ...state, isDisabled: action.payload };
    case 'SET_CURRENT_BARCODE_NUMBER':
      return { ...state, currentBarcodeNumber: action.payload };
    case 'GET_CATEGORIES_BY_MENU': {
      const categoriesData = action.payload.categories || action.payload || {};
      return {
        ...state,
        categoriesByMenu: Array.isArray(categoriesData)
          ? categoriesData
          : Object.values(categoriesData),
        categoriesTotalCount: action.payload.totalCount || 0,
        categoriesChangeCount: action.payload.changeCount || 0,
      };
    }
    case 'GET_PRODUCTS_BY_CATEGORY': {
      const productsData = action.payload.products || action.payload || {};
      return {
        ...state,
        productsByCategory: Array.isArray(productsData)
          ? productsData
          : Object.values(productsData),
      };
    }
    case 'GET_PRODUCTS_BY_MENU': {
      const productsData = action.payload.products || {};
      return {
        ...state,
        productsByMenu: Array.isArray(productsData)
          ? productsData
          : Object.values(productsData),
        productsTotalCount: action.payload?.totalCount || 0,
        productsChangeCount: action.payload?.changeCount || 0,
        totalInventory: action.payload?.totalInventory || 0,
        totalCost: action.payload?.totalCost || 0,
        totalSales: action.payload?.totalSales || 0,
      };
    }
    default:
      return state;
  }
};
